import {
  PARAM_CLI_SUCCES,
  PARAM_CLI_ECHEC,
  PARAM_UPDATE_SUCCES,
  PARAM_UPDATE_ECHEC,
} from "../constantes/paramAppConstantes";
import axios from "axios";

//const uri = `http://${manifest.debuggerHost.split(":").shift()}:5000`;
//const uri = `https://ecreal.herokuapp.com`;
//const uri = `https://ecreal.onrender.com`;
//const uri = `https://ahmed.prod-manager.tk/back`;
//const uri = `https://gestpro.globalsystempro.com/back`;
import { store } from "../store";
let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();
export const ParamParCliAction = () => async (dispatch, getState) => {
  try {
    /*  const {
      client: { client },
    } = getState();*/
    const { data } = await axios.get(`${uri}/api/paramApp`);
    dispatch({ type: PARAM_CLI_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: PARAM_CLI_ECHEC, payload: error.message });
  }
};

export const updateParamAction = (id, param) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    const { data } = await axios.put(
      `${uri}/api/paramApp/${id}`,
      param,
      config
    );
    dispatch({ type: PARAM_UPDATE_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: PARAM_UPDATE_ECHEC, payload: error });
  }
};
